<hpf-role-permission-form
	*ngIf="rolePermission"
	[rolePermission]="rolePermission"
	(create)="onCreate($event)"
></hpf-role-permission-form>
<div *ngIf="!rolePermission" class="my-5 text-center">
	<nz-spin nzSimple></nz-spin>
</div>
